import { Box, Chip, FormControlLabel, Switch } from '@mui/material';
import { blue } from '@mui/material/colors';
import { computed } from '@preact/signals-react';
import { t } from 'i18next';
import { ChangeEventHandler } from 'react';
import { ProfileStore } from '../../store/ProfileStore';

type Props = {
  store: ProfileStore;
  ruleNumber: number;
};

export const RuleToggle = ({ ruleNumber, store }: Props) => {
  const isEditable = store.isEditable();
  const isEnabled = computed(() => {
    return !store.getDisabledRules().has(ruleNumber);
  });

  const ariaLabel = isEditable ? t(`a11y.profile.ruleToggleStatus`) : t(`a11y.profile.${isEnabled ? 'ruleEnabled' : 'ruleDisabled'}`);

  const handleToggle: ChangeEventHandler<HTMLInputElement> = (e) => {
    const checked = e.target.checked;
    store.updateDisabledRulesState(checked, ruleNumber);
  };

  if (isEditable) {
    return (
      <FormControlLabel
        sx={{ m: 0 }}
        className="profile-column profile-content-column"
        control={
          <Switch
            data-role={`rule-toggle-${ruleNumber}`}
            tabIndex={-1}
            checked={isEnabled.value}
            onChange={handleToggle}
            inputProps={{ 'aria-label': ariaLabel, 'data-role': 'tabbable' }}
          />
        }
        label={<span aria-hidden>{isEnabled.value ? t('on') : t('off')}</span>}
      />
    );
  }

  return (
    <Box component="span" className="profile-column profile-content-column" data-role="tabbable" tabIndex={-1}>
      <Chip
        aria-label={ariaLabel}
        size="medium"
        data-role={`rule-status-${ruleNumber}`}
        sx={{
          border: '1px solid',
          borderColor: isEnabled.value ? 'primary.main' : 'grey.700',
          backgroundColor: isEnabled.value ? blue[50] : 'grey.200',
          color: 'text.primary',
          fontSize: '0.875rem',
          width: '4rem',
          '& .MuiChip-label': { px: 0 },
        }}
        label={isEnabled.value ? t('on') : t('off')}
      />
    </Box>
  );
};
